import { render, staticRenderFns } from "./Arrow.vue?vue&type=template&id=0b69cd4e&"
import script from "./Arrow.vue?vue&type=script&lang=ts&"
export * from "./Arrow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports